module.exports = __webpack_public_path__ + "img/80 x 50.112cb32e.jpg";